import { Box, useTheme } from '@mui/material'

type TaskListHeaderProps = {
  headerHeight: number
  rowWidth: string
  fontFamily: string
  fontSize: string
}

function TaskListHeader({
  headerHeight,
  fontFamily,
  fontSize,
  rowWidth,
}: TaskListHeaderProps) {
  const theme = useTheme()

  return (
    <Box sx={{ display: 'table', fontSize, fontFamily, width: rowWidth }}>
      <Box
        sx={{ display: 'table-row', listStyle: 'none', height: headerHeight }}
      >
        {['Task Name', 'Assignee', 'Start', 'End'].map((header: string) => (
          <Box
            key={header}
            sx={{
              display: 'table-cell',
              verticalAlign: 'middle',
              border: `1px solid ${theme.palette.grey[300]}`,
              p: '0 8px',
              minWidth: rowWidth,
              maxWidth: rowWidth,
            }}
          >
            {header}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default TaskListHeader
